import { mapMaterialCategoryType, MaterialCategoryType } from "./MaterialCategoryType";
import { mapMaterialDataTypes, MaterialDataType } from "./MaterialDataType";
import { mapMaterialEstimationTypes, MaterialEstimationType } from "./MaterialEstimationType";
import { mapMaterialSubCategoryType, MaterialSubCategoryType } from "./MaterialSubCategoryType";

export interface MaterialType {
    id: number;
    project_id: number | null;
    category_id: number | null;
    sub_category_id: number;
    length: number | null;
    width: number | null;
    hight: number | null;
    total_spend: number | null;
    data: MaterialDataType[];
    estimation: MaterialEstimationType[];
    material_category: MaterialCategoryType | null;
    material_sub_category: MaterialSubCategoryType | null;
}

// to single object maping
export const mapMaterialType = (data: any): MaterialType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialType: MaterialType = {
        id: data.id,
        project_id: data.project_id || null,
        category_id: data.category_id || null,
        sub_category_id: data.sub_category_id || null,
        length: data.length || null,
        width: data.width || null,
        hight: data.hight || null,
        total_spend: data.total_spend || null,
        data: Array.isArray(data.data) ? mapMaterialDataTypes(data.data) : [],
        estimation: Array.isArray(data.estimation) ? mapMaterialEstimationTypes(data.estimation) : [],
        material_category: data.material_category !== null ? mapMaterialCategoryType(data.material_category) : null,
        material_sub_category: (data.material_sub_category != null) ? mapMaterialSubCategoryType(data.material_sub_category) : null,
    }

    return materialType;
}

// maping list objects
export const mapMaterialTypes = (data: any[]): MaterialType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapMaterialType);
}